/**
 * Navigation Menu Items Configuration
 * This file contains the main navigation menu items for the restaurant website
 * Can be easily replaced with API calls in the future
 */

export const menuItems = [
  
  {
    id: 'shop',
    name: 'MENU',
    path: '/menu',
    icon: 'RestaurantMenu',
    order: 2,
    active: true,
    submenu: [
      {
        id: 'menu-full',
        name: 'Full Menu',
        path: '/menu',
        icon: 'RestaurantMenu',
        order: 1,
        active: true,
      },
      {
        id: 'specials',
        name: 'Daily Specials',
        path: '/menu/specials',
        icon: 'Star',
        order: 2,
        active: true,
      },
      {
        id: 'catering',
        name: 'Catering',
        path: '/menu/catering',
        icon: 'LocalDining',
        order: 3,
        active: true,
      },
    ],
  },
  {
    id: 'blog',
    name: 'BLOG',
    path: '/blog',
    icon: 'Article',
    order: 3,
    active: true,
    submenu: [
      {
        id: 'blog-main',
        name: 'BLOG',
        path: '/blog',
        icon: 'Article',
        order: 1,
        active: true,
      },
      {
        id: 'blog-details',
        name: 'BLOG DETAILS',
        path: '/blog/details',
        icon: 'Article',
        order: 2,
        active: true,
      },
    ],
  },
  {
    id: 'pages',
    name: 'PAGES',
    path: '/about',
    icon: 'Info',
    order: 4,
    active: true,
    submenu: [
      {
        id: 'about',
        name: 'About Us',
        path: '/about',
        icon: 'Info',
        order: 1,
        active: true,
      },
      {
        id: 'services',
        name: 'Services',
        path: '/services',
        icon: 'Support',
        order: 2,
        active: true,
      },
      {
        id: 'team',
        name: 'Our Team',
        path: '/team',
        icon: 'People',
        order: 3,
        active: true,
      },
    ],
  },
  {
    id: 'contact',
    name: 'CONTACT',
    path: '/contact',
    icon: 'ContactPhone',
    order: 5,
    active: true,
  },
];

/**
 * Get menu items from API (placeholder for future implementation)
 * @returns {Promise<Array>} Array of menu items
 */
export const getMenuItemsFromAPI = async () => {
  try {
    // Future API call: const response = await api.get('/menu-items');
    // return response.data;
    
    // For now, return static data
    return new Promise((resolve) => {
      setTimeout(() => resolve(menuItems), 100);
    });
  } catch (error) {
    console.error('Error fetching menu items:', error);
    return menuItems;
  }
};

/**
 * Get active menu items only
 * @returns {Array} Array of active menu items
 */
export const getActiveMenuItems = () => {
  return menuItems.filter(item => item.active);
};

/**
 * Get menu item by ID
 * @param {string} id - Menu item ID
 * @returns {Object|null} Menu item object or null
 */
export const getMenuItemById = (id) => {
  return menuItems.find(item => item.id === id) || null;
};

export default menuItems;
